// src/stone/icons/Zap.tsx
import { jsx } from "react/jsx-runtime";
var Zap = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M13.512.084a1 1 0 0 1 .591 1.041L13.134 8.8H22a1 1 0 0 1 .765 1.644l-11.111 13.2a1 1 0 0 1-1.757-.77l.969-7.674H2a1 1 0 0 1-.765-1.644L12.346.356a1 1 0 0 1 1.166-.272M4.15 13.2H12a1 1 0 0 1 .992 1.125l-.687 5.44 7.546-8.965H12a1 1 0 0 1-.992-1.125l.687-5.44z" })
  }
);
var Zap_default = Zap;

export {
  Zap_default
};
